import { ITableFieldDictionary } from 'src/app/interfaces/field-settings.interface';

const notificationContentDictionary: ITableFieldDictionary = {
    CalibrationGeneral: { label: 'The General table was updated in Zoning Code' },
    CalibrationOfficeCommercial: { label: 'The Use Capacity table was updated in Zoning Code' },
    CalibrationParking: { label: 'The Parking Table was updated in Zoning Code' },
    CalibrationUsesVals: { label: 'The Uses table was updated in Zoning Code' },
    CalibrationUsesLabels: { label: 'The Uses Label(s) were updated in Zoning Code' },
    CalibrationBonus: { label: 'The Bonus table was updated in Zoning Code' },
    CalibrationSetsAttributesStatistics: { label: 'CalibrationSet Attributes were updated' },
    CalibrationSetTableFieldsAttributesStatistics: { label: 'Calibration Set Table Field Attributes were updated' },
    publishingError: { label: 'in Zoning Code Draft publishing process: { label:' },
    publishingSuccess: { label: 'Zoning Code Draft successfully published' },
    SynchronizationMessage: {
        label: 'Draft was synchronized with original Zoning Code. Please refresh page to upload changes.'
    },
    zoningCodeAbsent: { label: 'ZoningCodeService.updateZoningCodeEntities => Zoning Code with Id' },
    ZoningCodeAttributesStatistics: { label: 'Zoning Code Attributes were updated' },
    ZoneCombination: { label: 'Zone was updated in Zoning Code' },
    OverlayTypology: { label: 'The Building Typology data for Overlay was updated in Zoning Code' },
    Overlay: { label: 'Overlay was updated in Zoning Code' }
};

export default notificationContentDictionary;
